<template>
  <header>
    <Header />
    <view-header />
    <video-overview />
    <side-by-sides />
    <Timeline />
    <Resources />
    <Support />
    <FAQs />
    <Future />
    <Footer />
  </header>
</template>

<script>
import Header from "./employerComponents/Header.vue";
import ViewHeader from "./employerComponents/ViewHeader.vue";
import SideBySides from "./employerComponents/SideBySides.vue";
import Timeline from "./employerComponents/Timeline.vue";
import Resources from "./employerComponents/Resources.vue";
import Support from "./employerComponents/Support.vue";
import VideoOverview from "./employerComponents/VideoOverview.vue";
import FAQs from "./employerComponents/FAQs.vue";
import Future from "./employerComponents/Future.vue";
import Footer from "./employerComponents/Footer.vue";

export default {
  metaInfo: {
    meta: [{ name: "robots", content: "noindex" }]
  },
  components: {
    Header,
    ViewHeader,
    SideBySides,
    Timeline,
    FAQs,
    Resources,
    Support,
    Future,
    Footer,
    VideoOverview
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  computed: {
    isMobile: function() {
      return this.windowWidth < 992;
    }
  }
};
</script>
